import React from "react";
import { Carousel } from "react-responsive-carousel";
import Section from "../Section/Section";
import { Link } from "react-router-dom";

const listOfModelIpodSlide1 = [
  {
    model: "Ремонт iPod Touch 1G, 2G, 3G",
    href: "/remont-apple/remont-ipod/1G-2G-3G",
  },
  {
    model: "Ремонт Touch Nano 5G",
    href: "/remont-apple/remont-ipod/5g",
  },
  {
    model: "Ремонт iPod Nano 6G",
    href: "/remont-apple/remont-ipod/nano-6g",
  },
  {
    model: "Ремонт iPod Nano 7G",
    href: "/remont-apple/remont-ipod/nano-7g",
  },
  {
    model: "Ремонт iPod Classic",
    href: "/remont-apple/remont-ipod/classic",
  },
  {
    model: "Ремонт iPod Mini Series 1",
    href: "/remont-apple/remont-ipod/classic",
  },
];

const listOfModelIpodSlide2 = [
  {
    model: "Ремонт iPod Mini Series 2",
    href: "/remont-apple/remont-ipod/classic",
  },
  {
    model: "Ремонт iPod Shuffle Series 1",
    href: "/remont-apple/remont-ipod/classic",
  },
  {
    model: "Ремонт iPod Shuffle Series 2",
    href: "/remont-apple/remont-ipod/classic",
  },
  {
    model: "Ремонт iPod Shuffle Series 3",
    href: "/remont-apple/remont-ipod/classic",
  },
  {
    model: "Ремонт iPod Shuffle Series 4",
    href: "/remont-apple/remont-ipod/classic",
  },
];

const RepairIpodModelLinksMobile = () => {
  return (
    <Section className="repair-iphone__models-links-container">
      <div className="repair-iphone-mobile__models-links-content">
        <h2 className="repair-iphone-mobile__models-links-title">
          Больше детальной информации по каждой модели:
        </h2>
        <Carousel
          autoPlay={false}
          infiniteLoop={true}
          swipeable={true}
          emulateTouch={true}
          showIndicators={true}
          stopOnHover={true}
          dynamicHeight={false}
          showThumbs={false}
          showStatus={false}
          showArrows={false}
        >
          <div className="repair-iphone-mobile__models-links-container">
            <ul className="repair-iphone-mobile__models-links-list">
              {listOfModelIpodSlide1.map((link, i) => {
                return (
                  <li
                    key={i}
                    className="repair-iphone-mobile__models-links-item"
                  >
                    <div className="repair-mb__links-mobile-icon"></div>
                    <Link
                      to={link.href}
                      className="repair-iphone-mobile__models-links-link"
                    >
                      {link.model}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="repair-iphone-mobile__models-links-container">
            <ul className="repair-iphone-mobile__models-links-list">
              {listOfModelIpodSlide2.map((link, i) => {
                return (
                  <li
                    key={i}
                    className="repair-iphone-mobile__models-links-item"
                  >
                    <div className="repair-mb__links-mobile-icon"></div>
                    <Link
                      to={link.href}
                      className="repair-iphone-mobile__models-links-link"
                    >
                      {link.model}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </Carousel>
      </div>
    </Section>
  );
};

export default RepairIpodModelLinksMobile;
